import React from "react";

export const DirectorMessage = (props) => {
  const data = props.data;

  return (
    <div id="director-message" className="director-message-section" style={{ padding: "60px 0", background: "#f6f6f6" }}>
      <div className="container">

        {/* Section title — plain row so float is cleared before the card */}
        <div className="row">
          <div className="col-xs-12 section-title text-center">
            <h2>Director's Message</h2>
          </div>
        </div>

        {/* Card row */}
        <div className="row">
          <div className="col-xs-12">
            <div
              className="director-message-card"
              style={{
                background: "#fff",
                borderRadius: 12,
                boxShadow: "0 0 50px rgba(0,0,0,0.06)",
                overflow: "hidden",
                display: "flex",
                flexWrap: "wrap",
                marginBottom: "20px",
              }}
            >
              {/* Left — Photo panel */}
              <div
                className="director-message-photo-panel"
                style={{
                  background: "linear-gradient(to right, #454751d1 0%, #ebb57dc4 100%)",
                  width: "100%",
                  maxWidth: 280,
                  minWidth: 200,
                  flexShrink: 0,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "48px 28px",
                }}
              >
                {/* Photo ring */}
                <div
                  className="director-message-photo-ring"
                  style={{
                    width: 150,
                    height: 150,
                    borderRadius: "50%",
                    padding: 4,
                    background: "rgba(255,255,255,0.25)",
                    boxShadow: "0 6px 24px rgba(0,0,0,0.2)",
                    marginBottom: 20,
                    flexShrink: 0,
                  }}
                >
                  <img
                    src={data?.photo || ""}
                    alt={data?.name || "Director"}
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "50%",
                      objectFit: "cover",
                      display: "block",
                      background: "rgba(255,255,255,0.15)",
                    }}
                  />
                </div>

                <h4 style={{ color: "#fff", margin: "0 0 6px", textAlign: "center" }}>
                  {data?.name || "Director Name"}
                </h4>
                <p style={{ color: "rgba(255,255,255,0.8)", fontSize: 13, margin: 0, textAlign: "center", lineHeight: 1.6 }}>
                  {data?.title || "Director & Founder"}
                </p>

                {/* Decorative dots */}
                <div style={{ display: "flex", gap: 6, marginTop: 22 }}>
                  {[1, 2, 3].map((i) => (
                    <div
                      key={i}
                      style={{
                        width: 7,
                        height: 7,
                        borderRadius: "50%",
                        background: i === 2 ? "#fff" : "rgba(255,255,255,0.4)",
                      }}
                    />
                  ))}
                </div>
              </div>

              {/* Right — Message panel */}
              <div
                className="director-message-text-panel"
                style={{
                  flex: 1,
                  minWidth: 0,
                  padding: "48px 44px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  position: "relative",
                  borderLeft: "4px solid #ed5810",
                }}
              >
                {/* Watermark quote */}
                <span
                  className="director-message-quote"
                  style={{
                    position: "absolute",
                    top: 10,
                    left: 28,
                    fontSize: 130,
                    lineHeight: 1,
                    fontFamily: "Georgia, serif",
                    color: "#a5743f",
                    opacity: 0.07,
                    userSelect: "none",
                    pointerEvents: "none",
                  }}
                >
                  &#8220;
                </span>

                <p
                  style={{
                    lineHeight: "24px",
                    margin: "10px 0 30px",
                    fontStyle: "italic",
                    position: "relative",
                    zIndex: 1,
                  }}
                >
                  {data?.message || "Loading..."}
                </p>

                {/* Signature */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 14,
                    borderTop: "1px solid #e8e8e8",
                    paddingTop: 18,
                  }}
                >
                  <div
                    style={{
                      width: 40,
                      height: 3,
                      background: "linear-gradient(to right, #a5743f 0%, #ed5810 100%)",
                      borderRadius: 2,
                      flexShrink: 0,
                    }}
                  />
                  <div>
                    <span style={{ display: "block", fontWeight: 700, color: "#333", fontSize: 15 }}>
                      {data?.name || "Director Name"}
                    </span>
                    <span style={{ color: "#888", fontSize: 13 }}>
                      {data?.title || "Director & Founder"}
                    </span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  );
};
